import './index.scss'
import NavigationSidebarItem from './NavigationSidebarItem'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { isNavigationAllowed, propertyNavRoutes } from './NavigationHelper'
import { ReactComponent as HomeIcon } from '../../../../assets/img/icons/home.svg'
import { ReactComponent as ShareIcon } from '../../../../assets/img/icons/share.svg'
import { ReactComponent as AnalyticsIcon } from '../../../../assets/img/icons/analytics.svg'
import { ReactComponent as EditIcon } from '../../../../assets/img/icons/edit.svg'
import React from 'react'

const NavigationSidebar = function (
  {
    permissions,
    property,
    onNavigate,
    showNewBadgeOnOcl,
  }
) {
  const { t } = useTranslation()
  if (!property || !permissions) return <div id="property-nav-sidebar">
    <div>
      <NavigationSidebarItem
        title={t('MY_PROPERTIES')}
        route={`/properties-list`}
        boldItem={true}
        onNavigate={() => {}}
        icon={<HomeIcon/>}
      />
    </div>
  </div>
  return <div id="property-nav-sidebar">
    <div style={{ marginBottom: '12px' }}>
      <NavigationSidebarItem
        title={t('MY_PROPERTIES')}
        route={`/properties-list`}
        boldItem={true}
        onNavigate={onNavigate}
        icon={<HomeIcon/>}
      />
    </div>
    <NavigationSidebarItem title={t('MANAGE_PROPERTY')} onNavigate={onNavigate} icon={<EditIcon/>}>
      {
        isNavigationAllowed(propertyNavRoutes.editProperty, permissions) && <NavigationSidebarItem
          title={t('EDIT_PROPERTY')}
          route={`/property/${property.giataId}/edit`}
          onNavigate={onNavigate}
        />
      }
      <NavigationSidebarItem
        title={t('EDIT_ROOMS')}
        route={`/property/${property.giataId}/edit-rooms`}
        onNavigate={onNavigate}
      />
      <NavigationSidebarItem
        title={t('IMAGES')}
        route={`/property/${property.giataId}/images`}
        onNavigate={onNavigate}
      />
    </NavigationSidebarItem>
    <NavigationSidebarItem title="Share Content" onNavigate={onNavigate} icon={<ShareIcon/>}>
      {
        isNavigationAllowed(propertyNavRoutes.ocl, permissions) && <NavigationSidebarItem
          title={t('OPEN_CONTENT_LINK')}
          route={`/property/${property.giataId}/open-content-link`}
          onNavigate={onNavigate}
          showNewBadge={showNewBadgeOnOcl}
        />
      }
      <NavigationSidebarItem
        title={t('contentMonitor.title')}
        route={`/property/${property.giataId}/content-monitor`}
        onNavigate={onNavigate}
      />
    </NavigationSidebarItem>
    <NavigationSidebarItem title={t('ANALYTICS_AND_INSIGHTS')} onNavigate={onNavigate} icon={<AnalyticsIcon/>}>
      {
        isNavigationAllowed(propertyNavRoutes.tourOperators, permissions) && <NavigationSidebarItem
          title={t('LABEL_TOUR_OPERATORS')}
          route={`/property/${property.giataId}/tour-operators`}
          onNavigate={onNavigate}
        />
      }
      {
        isNavigationAllowed(propertyNavRoutes.distribution, permissions) && <NavigationSidebarItem
          title={t('SALES_CHANNELS')}
          route={`/property/${property.giataId}/sales-channels`}
          onNavigate={onNavigate}
        />
      }
      {
        isNavigationAllowed(propertyNavRoutes.dashboard, permissions) && <NavigationSidebarItem
          title={t('TABLE_HEAD_DASHBOARD')}
          route={`/property/${property.giataId}/dashboard`}
          onNavigate={onNavigate}
        />
      }
      {
        isNavigationAllowed(propertyNavRoutes.compare, permissions)
        && <NavigationSidebarItem
          title={t('COMPARE_HOTELS')}
          route={`/property/${property.giataId}/compare-hotels`}
          onNavigate={onNavigate}
        />
      }
    </NavigationSidebarItem>
  </div>
}

NavigationSidebar.propTypes = {
  permissions: PropTypes.object,
  property: PropTypes.object,
  onNavigate: PropTypes.func,
  showNewBadgeOnOcl: PropTypes.bool,
}

export default NavigationSidebar
